import $ from 'jquery';
import 'select2';
import 'jquery-ui/ui/widgets/slider';
import { updateQueryStringParameter } from './common.js';

$('.js-select-sort').select2({
  placeholder: 'Mặc định',
  allowClear: false,
  minimumResultsForSearch: -1,
});

$('#js-sort').on('select2:select', function (e) {
  const data = e.params.data;
  const oldUrl = window.location.href;
  const newUrl = updateQueryStringParameter(oldUrl, 'orderby', data.id);
  return window.location.replace(newUrl);
});

$('.js-select-form').select2({
  placeholder: 'Chọn',
  allowClear: false,
  // minimumResultsForSearch: -1,
});
$(function () {
  const filterMaxPrice = Number($('#filterMaxPrice').val()) || 100000000;
  const minPrice = Number($('#min_price').val()) || 0;
  const maxPrice = Number($('#max_price').val()) || filterMaxPrice;

  $("#price-slider").slider({
    range: true,
    min: 0,
    max: filterMaxPrice,
    step: 100000,
    values: [minPrice, maxPrice],
    slide: function (event, ui) {
      const formattedMin = ui.values[0].toLocaleString('vi-VN') + ' đ';
      const formattedMax = ui.values[1].toLocaleString('vi-VN') + ' đ';
      $("#price_range_display").val(`${formattedMin} - ${formattedMax}`);

      $("#min_price").val(ui.values[0]);
      $("#max_price").val(ui.values[1]);
    }
  });

  // Khởi tạo hiển thị ban đầu
  const formattedMin = minPrice.toLocaleString('vi-VN') + ' đ';
  const formattedMax = maxPrice.toLocaleString('vi-VN') + ' đ';
  $("#price_range_display").val(`${formattedMin} - ${formattedMax}`);
});
document.addEventListener('DOMContentLoaded', function () {
  const filterForm = document.getElementById('filterForm');
  if (filterForm) {
    filterForm.addEventListener('submit', function (e) {
      const selectedBrands = Array.from(document.querySelectorAll('.brand-checkbox:checked'))
        .map(cb => cb.value)
        .join(',');
      document.getElementById('brandInput').value = selectedBrands;
    });
  }
  const resetFiltersBtn = document.getElementById('resetFiltersBtn');
  if (resetFiltersBtn) {
    resetFiltersBtn.addEventListener('click', function () {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      // Xoá các tham số lọc
      params.delete('min_price');
      params.delete('max_price');
      params.delete('brand');

      // Cập nhật lại URL và load lại trang
      url.search = params.toString();
      window.location.href = url.toString();
    });
  }
});

